import { Component, Input } from '@angular/core';

@Component({
  selector: 'split-header-form',
  templateUrl: './split-header-form.component.html',
  styleUrls: ['./split-header-form.component.scss']
})
export class SplitHeaderFormComponent {
    @Input() public icon!: string 
}
